(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[990,1290,9485,5593,8691],{

/***/ 46259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ scrollToBottomHeader; }
/* harmony export */ });
var scrollToBottomHeader = function scrollToBottomHeader(el) {
  var headerHeight = 38 + 66 + 6; // 38 is search bar height
  // 66 is header bar height
  // 6 is space between header and element to get perfect view

  window.scrollTo({
    top: el.getBoundingClientRect().top + window.pageYOffset - headerHeight,
    behavior: "smooth"
  });
};

/***/ }),

/***/ 68840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ FiCalendar; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FiCalendar(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "18",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "2",
        "x2": "16",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "2",
        "x2": "8",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "10",
        "x2": "21",
        "y2": "10"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 16091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91164);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30852);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);



var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/** Vendors **/

/** Components **/

/** ========== **/

/**
 *
 * @param {{
 * }} props Props for the component
 *
 */



var TawkToButton = function TawkToButton(_ref) {
  var children = _ref.children,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    onClick: /*#__PURE__*/(0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
      return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Tawk_API.toggle();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))
  }, props), {}, {
    children: children || "Talk To Our Expert Now"
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (TawkToButton);

/***/ }),

/***/ 38626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98989);
/* harmony import */ var components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68840);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);





/** ========== */





var PostItem = function PostItem(_ref) {
  var _post$categories;

  var post = _ref.post,
      layout = _ref.layout;
  var category = post === null || post === void 0 ? void 0 : (_post$categories = post.categories) === null || _post$categories === void 0 ? void 0 : _post$categories.nodes.filter(function (item) {
    return item.parent === null;
  });

  if (layout === "vertical") {
    var _post$featuredImage;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: "flex h-full flex-1 flex-col rounded-3xl bg-white transition-shadow duration-150 hover:shadow-[0px_0px_20px_#7c787833] xl:max-w-sm",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        image: post === null || post === void 0 ? void 0 : (_post$featuredImage = post.featuredImage) === null || _post$featuredImage === void 0 ? void 0 : _post$featuredImage.node,
        wrapper: {
          className: "w-full relative"
        },
        className: "aspect-[16/9] h-full w-full rounded-t-3xl object-cover"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "flex flex-1 flex-col justify-between p-6",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            as: "h3",
            className: "text-lg font-semibold text-bbc-brand-800 line-clamp-2",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              href: post === null || post === void 0 ? void 0 : post.uri,
              children: post === null || post === void 0 ? void 0 : post.title
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: "mt-4 line-clamp-3",
            dangerouslySetInnerHTML: {
              __html: post === null || post === void 0 ? void 0 : post.excerpt
            }
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "flex flex-wrap justify-between",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "mt-6 inline-flex items-center rounded-md bg-bbc-brand-800 px-2 py-0.5",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              src: "/assets/icons/".concat(category[0].name.toLowerCase(), ".svg"),
              alt: "icon",
              width: 16,
              height: 16
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              className: "inline-block pl-[5px] text-sm font-medium text-white",
              children: category.length > 0 && category[0].name
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "mt-6 inline-flex items-center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_0__/* .FiCalendar */ .v, {
              size: 18
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              className: "inline-block pl-2 text-sm",
              children: (0,common_functions__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p)(post === null || post === void 0 ? void 0 : post.date)
            })]
          })]
        })]
      })]
    });
  }

  if (layout === "horizontal") {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "text-bbc-brand-700",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          as: "h3",
          className: "text-lg font-medium line-clamp-2",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            href: post === null || post === void 0 ? void 0 : post.uri,
            children: post === null || post === void 0 ? void 0 : post.title
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "mt-6 inline-flex items-center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_0__/* .FiCalendar */ .v, {
            size: 18
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
            className: "inline-block pl-2 text-sm",
            children: (0,common_functions__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p)(post === null || post === void 0 ? void 0 : post.date)
          })]
        })]
      })
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {});
};

/* harmony default export */ __webpack_exports__["Z"] = (PostItem);
PostItem.defaultProps = {
  post: {},
  layout: "vertical"
};
/** ========== */

/***/ }),

/***/ 19190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(159);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27597);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/** ========== */




var RefundGuarantee = function RefundGuarantee(_ref) {
  var props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _ref);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "flex flex-col items-center justify-center text-center lg:flex-row lg:text-left",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        src: "/assets/icons/refund-guarantee.svg",
        width: 80,
        height: 80
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "mt-4 lg:mt-0 lg:ml-4",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
          className: "text-lg font-semibold",
          children: "Refund Guarantee"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
          className: "text-base font-normal",
          children: "We refund your money in full for services that we cannot deliver."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("em", {
          className: "text-sm font-medium leading-6 text-bbc-brand-500 underline",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            href: "/refund-policy",
            target: "_blank",
            children: "Read our policy"
          })
        })]
      })]
    })
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (RefundGuarantee);
/** ========== */

/***/ }),

/***/ 4330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EbookDownloadSection; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31741);
/* harmony import */ var components_templates_common_post_FormDownloadModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53693);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








function EbookDownloadSection(_ref) {
  var title = _ref.title,
      imgSrc = _ref.imgSrc,
      sectionClass = _ref.sectionClass,
      children = _ref.children,
      dataForm = _ref.dataForm,
      hash = _ref.hash,
      wrapper = _ref.wrapper,
      url = _ref.url;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      showFormDownload = _useState[0],
      setShowFormDownload = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      haveFormDownload = _useState2[0],
      setHaveFormDownload = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (document.getElementById("shortcode_download_form")) {
      setHaveFormDownload(true);
      document.querySelectorAll("#shortcode_download_form .btn").forEach(function (item) {
        item.addEventListener("click", function () {
          setShowFormDownload(true);
        });
      });
    }
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
    className: wrapper === null || wrapper === void 0 ? void 0 : wrapper.className,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "row justify-center",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        id: "ebook-download",
        className: "m-auto lg:col-10 lg:px-0",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          text: title,
          className: "bbc-title mb-6 px-5 text-center capitalize lg:mb-10 lg:px-0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "row flex-col-reverse justify-between lg:flex-row ".concat(sectionClass || ""),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "flex items-center justify-center lg:col-5",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread({
              className: " mt-6 w-full lg:mt-0",
              width: 360,
              height: 515
            }, imgSrc))
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: "lg:col-6",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              children: children
            }), dataForm ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              id: "shortcode_download_form",
              className: "btn mt-6 text-center lg:text-left",
              "data-type-shortcode": dataForm,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: "outline",
                className: "btn rounded-full border border-bbc-primary bg-transparent py-2 px-6 font-semibold text-bbc-primary hover:bg-bbc-primary hover:text-white",
                children: "Download Now"
              })
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: "mt-6 text-center lg:text-left",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                id: hash,
                variant: "outline",
                as: "a",
                href: url,
                children: "Download Now"
              })
            })]
          })]
        }), haveFormDownload && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_templates_common_post_FormDownloadModal__WEBPACK_IMPORTED_MODULE_5__["default"], {
          show: showFormDownload,
          onHide: function onHide() {
            return setShowFormDownload(false);
          },
          typeFormDownload: dataForm
        })]
      })
    })
  });
}

/***/ }),

/***/ 78354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91164);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["title", "subTitle", "data", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/** ========== */




var Component = function Component(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      data = _ref.data,
      children = _ref.children,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "row gap-y-6 lg:justify-end lg:gap-y-10",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: "col-12 lg:col-4",
          children: children ? children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            as: "h2",
            className: "text-center font-semibold lg:text-left",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              className: "block text-bbc-40px text-bbc-brand-800",
              children: title
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              className: "mt-4 block text-2xl  leading-9 ".concat(subTitle && subTitle === "in 4 easy steps" ? "text-bbc-brand-600" : "text-bbc-brand-800"),
              children: subTitle
            })]
          })
        }), (data === null || data === void 0 ? void 0 : data.length) > 0 && data.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            className: "col-12 lg:col-4",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                className: "mb-6 flex items-center justify-center rounded-full bg-white text-lg font-semibold text-bbc-yellow-500",
                style: {
                  width: "58px",
                  height: "58px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)"
                },
                children: index + 1
              }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                as: "h3",
                className: "mb-4 text-2xl font-medium text-bbc-brand-700 lg:mb-6 lg:font-semibold",
                children: item.title
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
                className: "leading-bbc-26 text-bbc-gray",
                dangerouslySetInnerHTML: {
                  __html: item.content
                }
              })]
            })
          }, index);
        })]
      })
    })
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);
Component.defaultProps = {
  data: []
};
/** ========== */

/***/ }),

/***/ 9485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NewsSlider; }
/* harmony export */ });
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5152);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98352);
/* harmony import */ var components_molecules_PostItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var PostSlider = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_0__["default"])(function () {
  return __webpack_require__.e(/* import() */ 2385).then(__webpack_require__.bind(__webpack_require__, 82385));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(82385)];
    },
    modules: ["../components/organisms/NewsSlider/index.js -> " + "components/organisms/PostSlider"]
  }
});

var CustomSwiperBreakpoint = function CustomSwiperBreakpoint(data) {
  return {
    320: {
      slidesPerView: 1,
      spaceBetween: 40,
      slidesPerGroup: 1,
      allowTouchMove: (data === null || data === void 0 ? void 0 : data.length) > 1,
      autoplay: {
        delay: (data === null || data === void 0 ? void 0 : data.length) > 1 ? 2500 : 9999999999,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      }
    },
    1024: {
      slidesPerView: (data === null || data === void 0 ? void 0 : data.length) < 2 ? data === null || data === void 0 ? void 0 : data.length : 2,
      spaceBetween: 30,
      slidesPerGroup: (data === null || data === void 0 ? void 0 : data.length) < 2 ? data === null || data === void 0 ? void 0 : data.length : 2,
      allowTouchMove: (data === null || data === void 0 ? void 0 : data.length) > 2,
      autoplay: {
        delay: (data === null || data === void 0 ? void 0 : data.length) > 2 ? 2500 : 9999999999,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      }
    },
    1280: {
      slidesPerView: (data === null || data === void 0 ? void 0 : data.length) < 3 ? data === null || data === void 0 ? void 0 : data.length : 3,
      spaceBetween: 30,
      slidesPerGroup: (data === null || data === void 0 ? void 0 : data.length) < 3 ? data === null || data === void 0 ? void 0 : data.length : 3,
      allowTouchMove: (data === null || data === void 0 ? void 0 : data.length) > 3,
      autoplay: {
        delay: (data === null || data === void 0 ? void 0 : data.length) > 3 ? 2500 : 9999999999,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      }
    }
  };
};

function NewsSlider(_ref) {
  var _data$posts, _data$posts2, _data$posts3;

  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(PostSlider, {
      navResponsiveClass: (data === null || data === void 0 ? void 0 : (_data$posts = data.posts) === null || _data$posts === void 0 ? void 0 : _data$posts.length) > 3 ? "" : "hidden lg:flex xl:hidden",
      breakpoints: CustomSwiperBreakpoint(data === null || data === void 0 ? void 0 : data.posts),
      children: Array.isArray(data.posts) && (data === null || data === void 0 ? void 0 : (_data$posts2 = data.posts) === null || _data$posts2 === void 0 ? void 0 : _data$posts2.length) > 0 && (data === null || data === void 0 ? void 0 : (_data$posts3 = data.posts) === null || _data$posts3 === void 0 ? void 0 : _data$posts3.map(function (item, index) {
        var _data$posts4;

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .SwiperSlide */ .o5, {
          className: "!h-auto lg:flex ".concat((data === null || data === void 0 ? void 0 : (_data$posts4 = data.posts) === null || _data$posts4 === void 0 ? void 0 : _data$posts4.length) === 2 && index < 1 ? "justify-end" : "justify-start"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_molecules_PostItem__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            post: item
          })
        }, index);
      }))
    })
  });
}

/***/ }),

/***/ 18691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91164);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88116);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98352);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9846);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);


var _excluded = ["className", "description", "imgAlt", "data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var StepSlider = function StepSlider(_ref) {
  var className = _ref.className,
      description = _ref.description,
      imgAlt = _ref.imgAlt,
      data = _ref.data,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
    className: " pt-10 lg:pt-24 ".concat(className),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        text: data.title,
        as: "h2",
        className: " mb-6 text-center text-3xl font-semibold capitalize text-bbc-brand-800 lg:mb-10 lg:text-4xl"
      }), description ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("p", {
        className: "mb-10 text-center",
        children: [" ", description]
      }) : null, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: "row justify-center",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: "col-12 mb-6 flex items-center justify-center lg:col-4 lg:mb-0 lg:justify-start",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            src: "/assets/images/offshore/country/bvi/bank_account-bvi.png",
            alt: imgAlt,
            width: 351,
            height: 350
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: "col-12 order-3 flex items-center justify-center lg:col-1 lg:order-2",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            className: "swiper-pagination-custom flex h-6 items-end justify-center lg:h-[370px] lg:w-fit lg:flex-col lg:pr-4"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: "col-12 order-2 self-center lg:col-6 lg:order-3 ",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, _objectSpread(_objectSpread({
              slidesPerView: 1,
              spaceBetween: 30,
              mousewheel: true,
              allowTouchMove: true,
              effect: "fade",
              fadeEffect: {
                crossFade: true
              },
              pagination: {
                el: ".swiper-pagination-custom",
                clickable: true,
                bulletClass: "pagination-bullet ",
                bulletActiveClass: "pagination-bullet-active bbc-pagination-bullet-active"
              },
              breakpoints: {
                320: {
                  allowTouchMove: true
                },
                1024: {
                  allowTouchMove: true
                }
              },
              modules: [swiper__WEBPACK_IMPORTED_MODULE_1__/* .Mousewheel */ .Gk, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl, swiper__WEBPACK_IMPORTED_MODULE_1__/* .EffectFade */ .xW],
              className: "mySwiper"
            }, props), {}, {
              children: data.steps && data.steps.length > 0 && data.steps.map(function (step, index) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                  className: "h-auto",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                    className: "step-slider h-full rounded-xl bg-transparent p-0 lg:bg-white lg:px-10 lg:pb-10 lg:pt-6",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                      as: "h3",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                        className: "mb-1 block text-lg font-medium text-bbc-brand-700",
                        children: step.index
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                        className: "mb-6 block text-lg font-semibold text-bbc-brand-600 lg:text-2xl",
                        children: step.titleStep
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                      className: "text-bbc-gray",
                      dangerouslySetInnerHTML: {
                        __html: step.description
                      }
                    })]
                  })
                }, index);
              })
            }))
          })
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (StepSlider);
StepSlider.defaultProps = {
  className: ""
};

/***/ }),

/***/ 53693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5152);
/* harmony import */ var components_atoms_Toast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85882);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
/**
 * Vendor
 */

/**
 * Components
 */




var FormDownload = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_0__["default"])(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9885), __webpack_require__.e(9669), __webpack_require__.e(7445)]).then(__webpack_require__.bind(__webpack_require__, 37445));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(37445)];
    },
    modules: ["../components/templates/common/post/FormDownloadModal/index.js -> " + "./FormDownload"]
  }
});

var FormDownloadModal = function FormDownloadModal(_ref) {
  var descriptionClass = _ref.descriptionClass,
      checkboxTextClassName = _ref.checkboxTextClassName,
      show = _ref.show,
      onHide = _ref.onHide,
      typeFormDownload = _ref.typeFormDownload;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Toast__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      children: show && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(FormDownload, {
        descriptionClass: descriptionClass,
        checkboxTextClassName: checkboxTextClassName,
        show: show,
        onHide: onHide,
        typeFormDownload: typeFormDownload
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (FormDownloadModal);
/** ========== */

/***/ }),

/***/ 44087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sg_foreigner_SGPackage; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./common/action-function/scrollToBottomHeader.js
var scrollToBottomHeader = __webpack_require__(46259);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/TabListNew/index.js
var TabListNew = __webpack_require__(32144);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.js
var fa = __webpack_require__(85809);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.js
var fi = __webpack_require__(10414);
// EXTERNAL MODULE: ./common/contexts.js
var contexts = __webpack_require__(72713);
// EXTERNAL MODULE: ./common/priceConvert.js
var priceConvert = __webpack_require__(46518);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Toast/index.js
var Toast = __webpack_require__(85882);
// EXTERNAL MODULE: ./components/molecules/PackageModal/index.js + 3 modules
var PackageModal = __webpack_require__(87258);
// EXTERNAL MODULE: ./components/templates/common/post/FormDownloadModal/index.js
var FormDownloadModal = __webpack_require__(53693);
// EXTERNAL MODULE: ./components/templates/sg/sg-foreigner/SGPackage/Index.module.scss
var Index_module = __webpack_require__(84686);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/sg/sg-foreigner/SGPackage/CardDesktop.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** * Vendors ***/












/** * Components ***/

/** * ========== ***/

/**
 *
 * @param {{
 * }} props Props for the component
 *
 */





var ChildContent = function ChildContent(_ref) {
  var content = _ref.content;

  if (content) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      children: content.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "inline-block pl-7 font-medium text-bbc-primary",
            dangerouslySetInnerHTML: {
              __html: item
            }
          })
        }, index);
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};

var ContentDynamicPrice = function ContentDynamicPrice(_ref2) {
  var item = _ref2.item;

  if (item.paramsContent && item.paramsContent.price) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      dangerouslySetInnerHTML: {
        __html: (0,priceConvert/* convertPriceOnString */.eY)(_objectSpread(_objectSpread({}, item), {}, {
          content: item.text
        }))
      }
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    dangerouslySetInnerHTML: {
      __html: item.text
    }
  });
};

var ActionContent = function ActionContent(_ref3) {
  var list = _ref3.list,
      dataSuffix = _ref3.dataSuffix;

  var _useState = (0,react.useState)(false),
      modalShow = _useState[0],
      setModalShow = _useState[1];

  var _useState2 = (0,react.useState)(false),
      showFormDownload = _useState2[0],
      setShowFormDownload = _useState2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [list.checkName && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Toast/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PackageModal["default"], {
          country_name: dataSuffix === null || dataSuffix === void 0 ? void 0 : dataSuffix.name,
          country_id: dataSuffix === null || dataSuffix === void 0 ? void 0 : dataSuffix.id,
          show: modalShow,
          onHide: function onHide() {
            return setModalShow(false);
          },
          suffix_data: dataSuffix === null || dataSuffix === void 0 ? void 0 : dataSuffix.suffixData
        })
      })
    }), list.ebook_download && /*#__PURE__*/(0,jsx_runtime.jsx)(FormDownloadModal["default"], {
      show: showFormDownload,
      onHide: function onHide() {
        return setShowFormDownload(false);
      },
      typeFormDownload: "checklist_delaware"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative  cursor-pointer",
      id: list.hash_id ? list.hash_id : null,
      onClick: function onClick() {
        list.checkName && setModalShow(true); // : list.ebook_download &&
        //   (list.dataForm
        //     ? showEbookBookModal(list.checklist_url)
        //     : showEbookBookModal(list.hash_id));
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "btn inline-block font-medium text-bbc-primary underline",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentDynamicPrice, {
          item: list
        })
      }), list.childContent && /*#__PURE__*/(0,jsx_runtime.jsx)(ChildContent, {
        content: list.childContent
      })]
    })]
  });
};

var ContentList = function ContentList(_ref4) {
  var _dataPackage$entitySu, _dataPackage$entitySu2, _dataPackage$entitySu3;

  var content = _ref4.content,
      dataPackage = _ref4.dataPackage,
      indexEntity = _ref4.indexEntity;
  var listContent = content.listContent,
      bottomContent = content.bottomContent;
  var countryId = dataPackage === null || dataPackage === void 0 ? void 0 : (_dataPackage$entitySu = dataPackage.entitySuffix) === null || _dataPackage$entitySu === void 0 ? void 0 : _dataPackage$entitySu.id;
  var dataSuffix = {
    id: countryId,
    name: dataPackage === null || dataPackage === void 0 ? void 0 : (_dataPackage$entitySu2 = dataPackage.entitySuffix) === null || _dataPackage$entitySu2 === void 0 ? void 0 : _dataPackage$entitySu2.sub_name,
    suffixData: dataPackage === null || dataPackage === void 0 ? void 0 : (_dataPackage$entitySu3 = dataPackage.entitySuffix) === null || _dataPackage$entitySu3 === void 0 ? void 0 : _dataPackage$entitySu3.EntityTypes[indexEntity]
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [listContent && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "pl-1.5",
      children: listContent.map(function (list, listIdx) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "mb-2 flex items-start last:mb-0 ",
          children: [!list.notCheck && /*#__PURE__*/(0,jsx_runtime.jsx)(fa/* FaCheck */.l_A, {
            className: " mr-2.5 mt-1.5 text-bbc-brand-500",
            size: 12,
            style: {
              minHeight: "12px",
              minWidth: "12px"
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex flex-col",
            children: list.checkName || list.ebook_download ? /*#__PURE__*/(0,jsx_runtime.jsx)(ActionContent, {
              list: list,
              dataSuffix: dataSuffix,
              indexEntity: indexEntity
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ContentDynamicPrice, {
              item: list
            })
          })]
        }, listIdx);
      })
    }), bottomContent && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mt-2",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PackageContent, {
        content: bottomContent,
        grid_class: "grid-flow-r"
      })
    })]
  });
};
var PackageContent = function PackageContent(_ref5) {
  var content = _ref5.content,
      grid_class = _ref5.grid_class,
      dataPackage = _ref5.dataPackage,
      indexEntity = _ref5.indexEntity;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "grid ".concat(grid_class || "grid-cols-2"),
    children: content.map(function (item, index) {
      var subTitle = item.subTitle,
          listContent = item.listContent,
          bottomContent = item.bottomContent;
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: listContent ? listContent && bottomContent ? "mb-0" : "mb-2 last:lg:mb-8" : " mb-0 ",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [subTitle && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mb-2 flex ",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "mr-2 mt-2 h-2 w-2 rounded-full bg-bbc-brand-500",
              style: {
                minHeight: "8px",
                minWidth: "8px"
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "font-semibold leading-bbc-26",
              dangerouslySetInnerHTML: {
                __html: subTitle
              }
            })]
          }), (listContent || bottomContent) && /*#__PURE__*/(0,jsx_runtime.jsx)(ContentList, {
            content: item,
            dataPackage: dataPackage,
            indexEntity: indexEntity
          })]
        })
      }, index);
    })
  });
};
var SaleItem = function SaleItem(_ref6) {
  var price_unit = _ref6.price_unit,
      sale_off = _ref6.sale_off,
      priceClass = _ref6.priceClass,
      textClass = _ref6.textClass;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "font-semibold ",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "mr-1 ".concat(textClass || "text-white"),
      children: "Save"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "inline-block rounded bg-bbc-green-500 p-1 text-sm leading-6 ".concat(priceClass || "text-white"),
      children: (0,priceConvert/* AutoConvertPriceWithUnit */.Nd)(sale_off, price_unit)
    })]
  });
};
var RenewalItem = function RenewalItem(_ref7) {
  var price_unit = _ref7.price_unit,
      renewal_fee = _ref7.renewal_fee,
      renewal_sub = _ref7.renewal_sub,
      className = _ref7.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: " ".concat(className || "mb-4 text-center text-sm italic  leading-6"),
    children: ["Renewal fee:", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "inline",
      dangerouslySetInnerHTML: {
        __html: (0,priceConvert/* AutoConvertPriceWithUnit */.Nd)(renewal_fee, price_unit) + (renewal_sub || "")
      }
    })]
  });
};

var CardDesktop = function CardDesktop(props) {
  var dataPackage = props.dataPackage,
      indexEntity = props.indexEntity,
      name = props.name,
      content = props.content,
      collapse_content = props.collapse_content,
      grid_class = props.grid_class,
      collapse_grid_class = props.collapse_grid_class,
      price = props.price,
      price_unit = props.price_unit,
      sale_off = props.sale_off,
      renewal_fee = props.renewal_fee,
      bestSeller = props.bestSeller,
      fee_bg_color = props.fee_bg_color,
      renewal_sub = props.renewal_sub,
      _props$btn_props = props.btn_props,
      btn_props = _props$btn_props === void 0 ? {
    othersClass: "border-2 hover:border-bbc-yellow-500",
    btnColor: "bg-transparent hover:bg-bbc-yellow-500",
    btnPadding: "px-10 py-2"
  } : _props$btn_props,
      countryId = props.countryId,
      entity_type_id = props.entity_type_id,
      id = props.id;

  var _useState3 = (0,react.useState)(false),
      seeMore = _useState3[0],
      setSeeMore = _useState3[1];

  var _useContext = (0,react.useContext)(contexts/* LayoutContext */.VY),
      currencyUnit = _useContext.currencyUnit;

  var linkRegister = "/onboarding/register?country_id=".concat(countryId, "&entity_type_id=").concat(entity_type_id, "&package_id=").concat(id);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex overflow-hidden rounded-2xl bg-white ",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mr-6 w-3/4 pt-12  pr-0 pl-10",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
        as: "h3",
        text: name,
        className: "mb-7 text-[32px] font-semibold uppercase leading-[42px] tracking-[0.25px] text-bbc-brand-700"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-7 flex items-center justify-between",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: " whitespace-nowrap pr-4 text-2xl font-semibold text-bbc-brand-700",
          children: "What's Included"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "h-[1px] w-full border border-bbc-brand-700 "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(PackageContent, {
        content: content,
        grid_class: grid_class,
        dataPackage: dataPackage,
        indexEntity: indexEntity
      }), collapse_content && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-12 mb-8 mt-6",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "".concat((Index_module_default()).collapseContent, " "),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "grid ".concat(collapse_grid_class || "grid-cols-2"),
            children: collapse_content.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "mb-2 flex ",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "mr-2 mt-2 h-2 w-2 rounded-full bg-bbc-brand-500",
                    style: {
                      minHeight: "8px",
                      minWidth: "8px"
                    }
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "font-semibold leading-bbc-26",
                    dangerouslySetInnerHTML: {
                      __html: item.subTitle
                    }
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "max-h-0  overflow-hidden ".concat(seeMore && " max-h-[900px]", " transition-all duration-150 ease-linear"),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentList, {
                    content: item,
                    grid_class: "grid-flow-col",
                    dataPackage: dataPackage,
                    indexEntity: indexEntity
                  })
                })]
              }, index);
            })
          }), !seeMore && /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
            className: "transition-color mx-auto mt-2 block cursor-pointer font-semibold text-bbc-brand-500 duration-150 hover:text-bbc-brand-700",
            onClick: function onClick() {
              setSeeMore(!seeMore);
            },
            children: [seeMore ? "See Less" : "See More", /*#__PURE__*/(0,jsx_runtime.jsx)(fi/* FiChevronsDown */.nlg, {
              className: "inline-block ".concat(seeMore ? "rotate-180" : "", " transition-transform duration-300"),
              size: 16
            })]
          })]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative w-1/4 overflow-hidden px-4 ".concat(fee_bg_color || "bg-bbc-brand-700 "),
      children: [bestSeller && /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/sg/company-incorporation-foreigners/best-seller.png",
        wrapper: {
          className: "absolute right-0 top-0"
        },
        width: 167,
        height: 172
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex h-full w-full flex-col items-center justify-center text-white lg:pt-14 lg:pb-6",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: " align-top text-xl font-medium leading-bbc-26",
            children: currencyUnit.value || price_unit
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "text-[60px] font-semibold leading-[90px] tracking-[0.25px] ",
            children: (0,priceConvert/* LocalStorageAutoConvertPrice */.DJ)(price, price_unit)
          })]
        }), sale_off && /*#__PURE__*/(0,jsx_runtime.jsx)(SaleItem, {
          price_unit: price_unit,
          sale_off: sale_off
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-7 mb-8 h-0 w-full border-b-2 border-b-white border-opacity-10",
          children: "\xA0"
        }), renewal_fee && /*#__PURE__*/(0,jsx_runtime.jsx)(RenewalItem, {
          price_unit: price_unit,
          renewal_fee: renewal_fee,
          renewal_sub: renewal_sub
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, _objectSpread(_objectSpread({
          as: "a",
          href: linkRegister
        }, btn_props), {}, {
          children: "Get Started"
        }))]
      })]
    })]
  });
};

/* harmony default export */ var SGPackage_CardDesktop = (CardDesktop);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(40037);
;// CONCATENATED MODULE: ./components/templates/sg/sg-foreigner/SGPackage/CardMobile.js




/**
 * Contexts
 */

/**
 * Components
 */






/** ========== */





var CardMobile = function CardMobile(_ref) {
  var data = _ref.data,
      dataPackage = _ref.dataPackage,
      indexEntity = _ref.indexEntity,
      linkRegister = _ref.linkRegister;

  var _ref2 = data || [],
      content = _ref2.content,
      notes = _ref2.notes,
      banner = _ref2.banner,
      bannerLink = _ref2.bannerLink,
      dataForm = _ref2.dataForm,
      bestSeller = _ref2.bestSeller,
      name = _ref2.name,
      sale_off = _ref2.sale_off,
      renewal_fee = _ref2.renewal_fee,
      price_unit = _ref2.price_unit,
      price = _ref2.price,
      renewal_sub = _ref2.renewal_sub,
      collapse_content = _ref2.collapse_content;

  var _useState = (0,react.useState)(false),
      showFormDownload = _useState[0],
      setShowFormDownload = _useState[1];

  var _useState2 = (0,react.useState)([]),
      seeMore = _useState2[0],
      setSeeMore = _useState2[1];

  var showEbookBookModal = function showEbookBookModal() {
    setShowFormDownload(true);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    style: {
      maxWidth: "350px"
    },
    className: " ".concat(bestSeller ? "mt-16" : "mt-6", " relative m-auto flex h-full flex-col justify-between rounded-3xl bg-white"),
    children: [bestSeller && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute -top-10 left-0 z-0 h-20 w-full rounded-t-[24px] bg-bbc-yellow-500 pt-1 text-center text-2xl font-semibold capitalize text-bbc-white",
      children: "Best Seller"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      style: {
        zIndex: "2",
        backgroundColor: "white",
        borderRadius: "24px"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          borderBottomWidth: "1.5px"
        },
        className: " border-b-bbc-neutral-500 px-8 pt-6  pb-7 text-center text-bbc-brand-700",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          style: {
            fontSize: "32px",
            lineHeight: "42px",
            letterSpacing: "0.25px"
          },
          className: "mb-8 font-semibold uppercase",
          children: name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          style: {
            fontSize: "50px",
            lineHeight: "54px",
            letterSpacing: "0.25px"
          },
          className: "mb-4 font-semibold",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: (0,priceConvert/* AutoConvertPriceWithUnit */.Nd)(price, price_unit)
          })
        }), sale_off && /*#__PURE__*/(0,jsx_runtime.jsx)(SaleItem, {
          price_unit: price_unit,
          sale_off: sale_off,
          priceClass: "text-white",
          textClass: "text-bbc-neutral-700"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "px-5 pb-6 pt-7 lg:pb-8",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PackageContent, {
          content: content,
          grid_class: "grid",
          dataPackage: dataPackage,
          indexEntity: indexEntity
        }), collapse_content && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "col-12 mb-2 ",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((Index_module_default()).collapseContent, " "),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "",
              children: collapse_content.map(function (item, index) {
                var id = item.subTitle.toLowerCase().split(" ").join("-");
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  id: id,
                  onClick: function onClick(e) {
                    if (seeMore.includes(id)) {
                      setSeeMore(seeMore.filter(function (itemId) {
                        return itemId !== id;
                      }));
                    } else {
                      setSeeMore([].concat((0,toConsumableArray/* default */.Z)(seeMore), [id]));
                      var elBoundingRect = document.getElementById(id);
                      (0,scrollToBottomHeader/* scrollToBottomHeader */.A)(elBoundingRect);
                    }
                  },
                  className: "cursor-pointer",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "mb-2 flex justify-between",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "flex",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "mr-2 mt-2 h-2 w-2 rounded-full bg-bbc-brand-500",
                        style: {
                          minHeight: "8px",
                          minWidth: "8px"
                        }
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "font-semibold leading-bbc-26",
                        dangerouslySetInnerHTML: {
                          __html: item.subTitle
                        }
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(fi/* FiChevronsDown */.nlg, {
                      className: "inline-block ".concat(seeMore.includes(id) ? "rotate-180" : "", " transition-transform duration-300 ease-in-out"),
                      size: 16,
                      color: "#007eff"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: " max-h-0 overflow-hidden ".concat(seeMore.includes(id) && "  max-h-[900px]", " transition-all duration-300 ease-in-out"),
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContentList, {
                      content: item,
                      grid_class: "grid-flow-col"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "pb-2"
                    })]
                  })]
                }, index);
              })
            })
          })
        }), (notes === null || notes === void 0 ? void 0 : notes.length) > 0 && notes.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("em", {
            className: "mt-2 block text-sm leading-6",
            dangerouslySetInnerHTML: {
              __html: item
            }
          }, index);
        }), banner && (bannerLink && bannerLink.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: dataForm ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            id: "shortcode_download_form",
            className: "mt-10 rounded-xl p-4",
            style: {
              background: "linear-gradient(165.49deg, rgba(117, 121, 231, 0.7) -116.25%, rgba(185, 255, 252, 0.7) 98.96%)"
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "font-semibold",
              children: "Stay on top of your business finances with our banking guideline"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              onClick: function onClick() {
                return showEbookBookModal();
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                className: "mx-auto mt-6 h-auto w-fit cursor-pointer",
                src: banner,
                alt: "package banner",
                width: 300,
                height: 192,
                wrapper: {
                  className: "w-full "
                }
              })
            }), dataForm && /*#__PURE__*/(0,jsx_runtime.jsx)(FormDownloadModal["default"], {
              show: showFormDownload,
              onHide: function onHide() {
                return setShowFormDownload(false);
              },
              typeFormDownload: "banking_guide"
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: bannerLink,
            rel: "nofollow",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              className: "mx-auto mt-6 h-auto w-fit cursor-pointer",
              src: banner,
              alt: "package banner",
              width: 300,
              height: 192,
              wrapper: {
                className: "w-full "
              }
            })
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          className: "mx-auto mt-6 h-auto w-fit",
          src: banner,
          alt: "package banner",
          width: 300,
          height: 192,
          wrapper: {
            className: "w-full "
          }
        }))]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      style: {
        borderTopWidth: "1.5px"
      },
      className: " border-t-bbc-neutral-500 px-5 pt-8 pb-6 text-center",
      children: [renewal_fee && /*#__PURE__*/(0,jsx_runtime.jsx)(RenewalItem, {
        price_unit: price_unit,
        renewal_fee: renewal_fee,
        renewal_sub: renewal_sub,
        className: "mb-3 text-lg font-medium italic text-bbc-brand-700"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: linkRegister,
        className: "inline-block w-full cursor-pointer  rounded-full border border-bbc-brand-500 py-2 px-6 font-normal text-bbc-brand-500 transition-all duration-150 hover:bg-bbc-brand-500 hover:!font-medium hover:text-white",
        children: "Get Started"
      })]
    })]
  });
};

/* harmony default export */ var SGPackage_CardMobile = (CardMobile);
CardMobile.defaultProps = {
  notes: [],
  content: [],
  index: 0
};
/** ========== */
;// CONCATENATED MODULE: ./components/templates/sg/sg-foreigner/SGPackage/index.js


function SGPackage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function SGPackage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SGPackage_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SGPackage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








/**
 *
 * @param {{
 * title: String;
 * description:String;
 * }} props Props for the component
 *
 */




var SGPackage = function SGPackage(props) {
  var _dataFromAPI$entitySu, _dataEntitySuffix$, _dataFromAPI$entitySu2, _dataFromAPI$entitySu3, _dataFromAPI$entitySu4;

  var title = props.title,
      description = props.description,
      listPackage = props.listPackage,
      data = props.data,
      reverse = props.reverse,
      note = props.note;
  var cardDarkList = listPackage.filter(function (item) {
    return item.card_type === "dark";
  });
  var cardLightList = listPackage.filter(function (item) {
    return item.card_type === "light";
  });
  var dataFromAPI = data === null || data === void 0 ? void 0 : data.dataPackage;
  var dataEntitySuffix = dataFromAPI === null || dataFromAPI === void 0 ? void 0 : (_dataFromAPI$entitySu = dataFromAPI.entitySuffix) === null || _dataFromAPI$entitySu === void 0 ? void 0 : _dataFromAPI$entitySu.EntityTypes;
  var dataPackage = dataFromAPI.packages;

  var _useState = (0,react.useState)(0),
      defaultTab = _useState[0],
      setDefaultTab = _useState[1];

  var temp = dataEntitySuffix === null || dataEntitySuffix === void 0 ? void 0 : dataEntitySuffix.reduce(function (totalID, currentValue) {
    totalID.push("".concat(currentValue.guid, "-package"));
    return totalID;
  }, []);
  var dataLink = "".concat((_dataEntitySuffix$ = dataEntitySuffix[0]) === null || _dataEntitySuffix$ === void 0 ? void 0 : _dataEntitySuffix$.guid, "-package");
  (0,react.useEffect)(function () {
    if (dataLink.length > 0) {
      var url = window.location.href;
      setDefaultTab(temp.indexOf(url.split("#")[1]) < 0 ? 0 : temp.indexOf(url.split("#")[1]));

      if (url.search("#".concat(url.split("#")[1])) > 0) {
        var scrollToTable = document.getElementById("PriceTable");
        (0,scrollToBottomHeader/* scrollToBottomHeader */.A)(scrollToTable);
      }
    }
  }, []);
  (0,react.useEffect)(function () {
    if (dataLink.length == 0) {
      setDefaultTab(0);
    }
  }, []);
  var checkLengthContent = dataEntitySuffix === null || dataEntitySuffix === void 0 ? void 0 : dataEntitySuffix.map(function (item) {
    return item.name;
  }).join(" ").length;
  var countryId = dataFromAPI === null || dataFromAPI === void 0 ? void 0 : (_dataFromAPI$entitySu2 = dataFromAPI.entitySuffix) === null || _dataFromAPI$entitySu2 === void 0 ? void 0 : _dataFromAPI$entitySu2.id;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    id: "PriceTable",
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
      text: title,
      className: "bbc-title text-center ".concat(description && description.length ? " mb-6" : " mb-6 lg:mb-10")
    }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: description
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TabListNew/* default */.Z, {
      activeTab: defaultTab,
      data: dataEntitySuffix === null || dataEntitySuffix === void 0 ? void 0 : dataEntitySuffix.map(function (item) {
        return item.name;
      }),
      tabLinks: dataEntitySuffix === null || dataEntitySuffix === void 0 ? void 0 : dataEntitySuffix.map(function (item) {
        return "".concat(item.guid, "-package");
      }),
      tabListClass: SGPackage_objectSpread(SGPackage_objectSpread({}, checkLengthContent > 30 && {
        display: "block md:flex justify-center",
        border: "border-0 md:border border-bbc-neutral-600",
        background: "bg-transparent md:bg-white"
      }), {}, {
        othersClass: "md:whitespace-nowrap "
      }),
      tabClass: SGPackage_objectSpread({
        tabColor: " text-bbc-neutral-600 hover:text-bbc-brand-500 border-bbc-neutral-600 md:border-transparent mx-auto",
        tabColorActive: "text-bbc-brand-500 border-bbc-brand-500 bg-white"
      }, checkLengthContent > 30 && {
        othersClass: "my-1 md:my-0  mx-auto"
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panels */.OK.Panels, {
        className: "mt-6 w-full ",
        children: (_dataFromAPI$entitySu3 = dataFromAPI.entitySuffix) === null || _dataFromAPI$entitySu3 === void 0 ? void 0 : (_dataFromAPI$entitySu4 = _dataFromAPI$entitySu3.EntityTypes) === null || _dataFromAPI$entitySu4 === void 0 ? void 0 : _dataFromAPI$entitySu4.map(function (entity, indexEntity) {
          var EntityFilterPackage = dataPackage.filter(function (item) {
            return item.EntityType.id === entity.id;
          });

          var filterByCardType = function filterByCardType(cardArray) {
            var _mergeData$Services, _mergeData$Services2, _dataFromAPI$dataRene, _dataFromAPI$dataRene2;

            var filterStaticCardData = cardArray.find(function (item) {
              return item.entityTypeId === entity.id;
            });
            var filterDynamicCardData = EntityFilterPackage.find(function (item) {
              return item.id === filterStaticCardData.id;
            });

            var mergeData = SGPackage_objectSpread(SGPackage_objectSpread({}, filterStaticCardData), filterDynamicCardData);

            var price = mergeData === null || mergeData === void 0 ? void 0 : (_mergeData$Services = mergeData.Services) === null || _mergeData$Services === void 0 ? void 0 : _mergeData$Services.reduce(function (sum, item) {
              var _item$Fee;

              return sum + (item === null || item === void 0 ? void 0 : (_item$Fee = item.Fee) === null || _item$Fee === void 0 ? void 0 : _item$Fee.value);
            }, 0);
            var discount = mergeData === null || mergeData === void 0 ? void 0 : (_mergeData$Services2 = mergeData.Services) === null || _mergeData$Services2 === void 0 ? void 0 : _mergeData$Services2.reduce(function (sum, item) {
              if (item.service_type_id === 49) {
                var _item$Fee2;

                return sum + (item === null || item === void 0 ? void 0 : (_item$Fee2 = item.Fee) === null || _item$Fee2 === void 0 ? void 0 : _item$Fee2.value);
              }

              return sum;
            }, 0);
            var renewal_fee = ((_dataFromAPI$dataRene = dataFromAPI.dataRenewal.find(function (item) {
              return item.mapping_package_id === mergeData.id;
            })) === null || _dataFromAPI$dataRene === void 0 ? void 0 : (_dataFromAPI$dataRene2 = _dataFromAPI$dataRene.Services) === null || _dataFromAPI$dataRene2 === void 0 ? void 0 : _dataFromAPI$dataRene2.reduce(function (sum, item) {
              var _item$Fee3;

              return sum + (item === null || item === void 0 ? void 0 : (_item$Fee3 = item.Fee) === null || _item$Fee3 === void 0 ? void 0 : _item$Fee3.value);
            }, 0)) || 0;
            return SGPackage_objectSpread(SGPackage_objectSpread(SGPackage_objectSpread(SGPackage_objectSpread(SGPackage_objectSpread({}, filterStaticCardData), filterDynamicCardData), {}, {
              price: price,
              countryId: countryId
            }, discount != 0 && {
              sale_off: Math.abs(discount)
            }), renewal_fee != 0 && {
              renewal_fee: Math.abs(renewal_fee)
            }), {}, {
              name: mergeData.PackageType.name
            });
          };

          var cardDark = filterByCardType(cardDarkList);
          var cardLight = filterByCardType(cardLightList);
          var dataAll = [cardDark, cardLight];
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(headlessui_esm/* Tab.Panel */.OK.Panel, {
            className: "focus:outline-none focus:outline-0 focus:ring-0",
            as: "div",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "hidden grid-flow-row  gap-y-10 lg:grid ",
              children: [cardDark && /*#__PURE__*/(0,jsx_runtime.jsx)("div", SGPackage_objectSpread(SGPackage_objectSpread({
                id: cardDark.el_id
              }, reverse && {
                className: "order-1"
              }), {}, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(SGPackage_CardDesktop, SGPackage_objectSpread({
                  dataPackage: dataFromAPI,
                  indexEntity: indexEntity
                }, cardDark))
              })), cardLight && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                id: cardLight.el_id,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(SGPackage_CardDesktop, SGPackage_objectSpread({
                  dataPackage: dataFromAPI,
                  indexEntity: indexEntity
                }, cardLight))
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "block w-full lg:hidden",
              children: listPackage && listPackage.map(function (item) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  id: "".concat(item.el_id, "-mobile"),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(SGPackage_CardMobile, {
                    data: SGPackage_objectSpread(SGPackage_objectSpread({}, item), dataAll.find(function (pack) {
                      return pack.id === item.id;
                    })),
                    linkRegister: "/onboarding/register?country_id=".concat(countryId, "&entity_type_id=").concat(entity.id, "&package_id=").concat(item.id),
                    dataPackage: dataFromAPI,
                    indexEntity: indexEntity
                  })
                }, "".concat(item.el_id, "-mobile"));
              })
            })]
          }, "".concat(indexEntity, "-mb"));
        })
      })
    }), note && /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
      className: "mt-6 block rounded-2xl bg-[#F5F5F5] px-4 py-6 text-sm leading-6 lg:mt-10 lg:px-10",
      dangerouslySetInnerHTML: {
        __html: note
      }
    })]
  });
};

/* harmony default export */ var sg_foreigner_SGPackage = (SGPackage);

/***/ }),

/***/ 97169:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fee":"Index_fee__G_lYE"};

/***/ }),

/***/ 84686:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"collapseContent":"Index_collapseContent__r2s4q"};

/***/ })

}]);